// extracted by mini-css-extract-plugin
export default {"root":"KeyFeatures__root--VqyFq"};